// export const backendURL = "backend-service.main-namespace"
export const backendURL = process.env.REACT_APP_HOST;
export const backendWS = process.env.REACT_APP_WS;

// export const backendURL = "54.160.88.52"
// export const backendURL = "localhost:8000"
